module.exports = __webpack_public_path__ + "img/fengcai4.50f7800b.jpg";